import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
// const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getShipmentsService = async (pageNumber: string) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/shipments?page=${pageNumber}`);
  return res;
};

export const getShipmentsMaterialsService = async (shipmentID: string) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/shipments/${shipmentID}/materials`);
  return res;
};

export const getMaterialService = async (materialID: string) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/shipments/materials/${materialID}`);
  return res;
};

export const getShipmentPDF = async (fileName: string) => {
  // const token = cookies.get("TOKEN");
  // axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  // const res = await axios.get(`${apiURL}/metalstrading/api/purchases/download/${fileName}`);
  // return res;
};

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

// export const postBillService = async (payload: any) => {
//   const token = cookies.get("TOKEN");
//   const userID = cookies.get("USER_ID");
//   axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
//   payload.createdByUserID = userID;
//   const res = await axios.post(`${apiURL}/metalstrading/api/bills`, payload);
//   return res;
// };

export const deleteShipmentService = async (shipmentID: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.delete(`${apiURL}/metalstrading/api/shipments/${shipmentID}`);
  return res;
};
